import React, { useState, useRef, useCallback, memo } from "react";
import Nav from "../components/Nav";
import { useNavContext } from "../context/NavContext";
import Breadcrumb from "../components/Breadcrumb";

export default function CartaEnvio() {
  // ===== Estado =====
  const [ciudad, setCiudad] = useState("El Salto, Jal.");
  const [fechaLarga, setFechaLarga] = useState("martes, 4 de febrero de 2025");

  // REMITENTE
  const [remitenteEmpresa, setRemitenteEmpresa] = useState(
    "UNIFICACIÓN PARA LA AUTOMATIZACIÓN SA DE CV"
  );
  const [remitenteDir1, setRemitenteDir1] = useState(
    "Lic Ramiro Hernández 448, Las Pintitas, C.P. 45693"
  );
  const [remitenteCiudad, setRemitenteCiudad] = useState(
    "El Salto, Jalisco, México"
  );
  const [remitenteAtn, setRemitenteAtn] = useState(
    "Jose Carlos Campos Rodriguez"
  );
  const [remitenteTelefono, setRemitenteTelefono] = useState("3321235662");

  // DESTINATARIO
  const [destEmpresa, setDestEmpresa] = useState(
    "CABLES DE ACERO Y ESLINGAS S.A. DE C.V."
  );
  const [destAtn, setDestAtn] = useState("Reynaldo Luna Roblero");
  const [destDireccion, setDestDireccion] = useState(
    "Cobre 64, Industrial Esfuerzo Nal, Ecatepec de Morelos,\nEstado de México, C.P. 55320"
  );
  const [destTelefono, setDestTelefono] = useState("55 2756 2608");

  const [isEditing, setIsEditing] = useState(true);

  const logoSrc = "/img/logo-comercial.svg";
  const { proximasAVencer, proximosEventos } = useNavContext();

  // ===== Estilos (pantalla) =====
  const GAP = 20;

  const outer = {
    background: "#f5f7fa",
    minHeight: "100dvh",
    paddingBlock: GAP,
  };

  const page = {
    maxWidth: 1220,
    margin: `${GAP}px auto`,
    background: "#fff",
    padding: "48px 72px 56px",
    fontFamily: "Arial, Helvetica, sans-serif",
    color: "#111",
    lineHeight: 1.6,
    boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
    minHeight: 1280,
    display: "flex",
    flexDirection: "column",
    position: "relative",
  };

  const content = {
    maxWidth: 1120,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: "100%",
  };

  const header = {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 12,
  };

  const cityDate = { textAlign: "right", fontSize: 20, fontWeight: 700 };

  const ruleRow = { display: "block", marginTop: 22, marginBottom: 30 };
  const blueRule = {
    height: 8,
    width: "100%",
    background: "#0A6CA9",
    borderRadius: 2,
  };

  const title = {
    textAlign: "center",
    margin: "5px",
    fontSize: 35,
    letterSpacing: 0.3,
    fontWeight: 800,
  };

  const centerBlock = { textAlign: "center" };
  const label = {
    fontSize: 28,
    fontWeight: 800,
    letterSpacing: 0.4,
    marginTop: 20,
    marginBottom: 10,
  };
  const line = { fontSize: 26, margin: "14px 0", whiteSpace: "pre-line" };
  const lineBig = {
    fontSize: 30,
    margin: "12px 0",
    whiteSpace: "pre-line",
    fontWeight: 800,
  };
  const atnRow = { fontSize: 26, margin: "10px 0 6px" };

  const footerBarsWrap = {
    marginTop: 36,
    display: "flex",
    width: "100%",
    height: 22,
  };
  const footerBlue = { background: "#0A6CA9", width: "60%" };
  const footerDark = { background: "#3D3D3D", width: "40%" };

  // ===== Editable =====
  const Editable = memo(
    function Editable({
      enabled,
      initialText,
      onCommit,
      underline = false,
      bold = false,
      ariaLabel,
      style,
      block = false,
      color,
    }) {
      const ref = useRef(null);
      const inited = useRef(false);
      const [focused, setFocused] = useState(false);

      const setNode = useCallback(
        (node) => {
          if (!node) return;
          ref.current = node;
          if (!inited.current) {
            node.textContent = initialText || "";
            inited.current = true;
          }
        },
        [initialText]
      );

      const handleBlur = useCallback(() => {
        setFocused(false);
        if (onCommit && ref.current) onCommit(ref.current.textContent || "");
      }, [onCommit]);

      const handleFocus = useCallback(() => setFocused(true), []);
      const handleKeyDown = useCallback(
        (e) => {
          if (!block && e.key === "Enter") e.preventDefault();
        },
        [block]
      );

      const handlePaste = useCallback(
        (e) => {
          if (!enabled) return;
          e.preventDefault();
          const text = (e.clipboardData || window.clipboardData).getData(
            "text"
          );
          document.execCommand("insertText", false, text);
        },
        [enabled]
      );

      const redBase = "#ef4444";
      const redLight = "#fca5a5";
      const redBg = "#fef2f2";

      const editableBox = enabled
        ? {
            background: redBg,
            border: `1px dashed ${focused ? redBase : redLight}`,
            boxShadow: focused ? "0 0 0 2px rgba(239,68,68,.10)" : "none",
            borderRadius: 6,
            transition: "box-shadow .15s ease, border-color .15s ease",
          }
        : {};

      const sizing =
        enabled && block
          ? { display: "inline-block", padding: "4px 6px", minHeight: 28 }
          : enabled
          ? { display: "inline-block", padding: "0 4px", lineHeight: 1.2 }
          : { display: "inline" };

      return (
        <span
          ref={setNode}
          role="textbox"
          aria-label={ariaLabel}
          contentEditable={enabled}
          suppressContentEditableWarning
          spellCheck={false}
          className={`ce-editable${block ? " ce-block" : ""}`}
          onBlur={enabled ? handleBlur : undefined}
          onFocus={enabled ? handleFocus : undefined}
          onKeyDown={enabled ? handleKeyDown : undefined}
          onPaste={enabled ? handlePaste : undefined}
          style={{
            boxSizing: "border-box",
            textDecoration: underline ? "underline" : "none",
            fontWeight: bold ? 800 : undefined,
            color: color || "inherit",
            cursor: enabled ? "text" : "default",
            verticalAlign: "baseline",
            ...sizing,
            ...editableBox,
            ...style,
          }}
        />
      );
    },
    (prev, next) =>
      prev.enabled === next.enabled &&
      prev.block === next.block &&
      prev.underline === next.underline &&
      prev.bold === next.bold &&
      prev.color === next.color
  );

  // ===== Imprimir =====
  const handlePrint = () => {
    const wasEditing = isEditing;
    setIsEditing(false);

    requestAnimationFrame(() => {
      const pageNode = document.querySelector(".ce-page");
      if (!pageNode) return;

      const html = `
<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<title>Carta Envío</title>
<style>
  /* Márgenes del navegador = 0; controlamos con .ce-content */
  @page { size: A4; margin: 0; }

  * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  html, body { height: 100%; }
  body {
    margin:0;
    font-family: Arial, Helvetica, sans-serif;
    color:#111; line-height:1.5; font-size:13.5px;
    background:#fff;
  }

  .print-sheet{ position:relative; height:297mm; overflow:hidden; }

  /* Quita cualquier estilo inline molestando (box shadow, margins, paddings) */
  .ce-page{
    box-shadow:none !important;
    margin: 15px !important;
    padding: 15px !important;
    position:relative;
    height:297mm;             /* A4 vertical */
    display:flex; flex-direction:column;
    overflow:hidden;
    background:#fff;
  }

  /* Respira 6mm arriba, 12mm lados y fondo */
  .ce-content{
    max-width:none;
    margin:6mm 12mm 12mm;
    padding:0 0 52px 0;  /* que el footer no tape texto */
    display:flex; flex-direction:column; min-height:100%;
    box-sizing:border-box;
    text-align:center;
  }

  /* Header en impresión (por si dependías de estilos inline) */
  .ce-header{ display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:8px; }
  .ce-citydate{ text-align:right; font-size:16px; font-weight:700; }

  /* Línea azul única */
  .ce-bluebar{ width:100%; height:8px; background:#0A6CA9; border-radius:2px; }

  /* Tipografías en impresión */
  h2{ font-size:30px; margin:16px 0 14px; letter-spacing:.3px; font-weight:800; text-align:center; }
  .ce-label{ font-size:19px; font-weight:800; margin:20px 0 8px; letter-spacing:.3px; }
  .ce-line{ font-size:18px; line-height:1.5; margin:8px 0 10px; white-space:pre-line; }
  .ce-line.ce-big{ font-size:22px; font-weight:800; margin:8px 0 10px; }
  .ce-atn{ font-size:18px; margin:6px 0 6px; }

  /* Forzar limpieza de bordes rojos de edición */
  .ce-editable{
    background:transparent;
    border:none;
    box-shadow:none;
    padding:0;
    display:inline;
  }
  .ce-editable.ce-block{ display:inline; }

  /* Footer fijo dentro del área útil */
  .footer-bars{
  position: fixed;
  inset: auto 0 0 0; /* pega a ambos lados y al borde inferior */
  height: 22px;
  display: flex;
  margin: 0;
  z-index: 9999;
  }
  .footer-blue{ background:#0A6CA9; width:60%; }
  .footer-dark{ background:#3D3D3D; width:40%; }

  .ce-page, .ce-content, .ce-page * { page-break-inside: avoid; }
</style>
</head>
<body>
  <div class="print-sheet">${pageNode.outerHTML}</div>
</body>
</html>`.trim();

      // Imprimir en iframe oculto
      const iframe = document.createElement("iframe");
      Object.assign(iframe.style, {
        position: "fixed",
        right: 0,
        bottom: 0,
        width: "0",
        height: "0",
        border: 0,
      });
      document.body.appendChild(iframe);

      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();

      let finished = false;
      const cleanup = () => {
        if (finished) return;
        finished = true;
        setIsEditing(wasEditing);
        setTimeout(() => iframe.remove(), 0);
      };

      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        }, 0);
      };

      iframe.contentWindow.addEventListener("afterprint", cleanup, {
        once: true,
      });
      setTimeout(cleanup, 5000); // fallback
    });
  };

  return (
    <>
      <Nav
        handleSearch={() => {}}
        proximasAVencer={proximasAVencer}
        proximosEventos={proximosEventos}
      />

      {/* Barra superior */}
      <div
        className="task-filters"
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "nowrap",
          gap: 8,
          borderBottom: "none",
        }}
      >
        {/* Izquierda: Breadcrumb */}
        <div
          style={{
            flex: 1,
            padding: "0 4px",
            minHeight: 36,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Breadcrumb
            aliases={{
              personalizacion: "Personalizacion",
              "carta-poder": "Carta Poder",
            }}
          />
        </div>

        {/* Derecha: Botones */}
        <div
          className="task-filters-right"
          style={{ display: "flex", alignItems: "center", gap: 10 }}
        >
          <button
            className="exportar-button"
            onClick={handlePrint}
            title="Imprimir"
          >
            Imprimir
          </button>
          <button
            className="new-task-button"
            onClick={() => setIsEditing((v) => !v)}
            title={isEditing ? "Guardar" : "Editar"}
          >
            {isEditing ? "Guardar" : "Editar"}
          </button>
        </div>
      </div>

      {/* Página */}
      <div style={outer} className="ce-outer">
        <div style={page} className="ce-page">
          <div style={content} className="ce-content">
            {/* Encabezado */}
            <div style={header} className="ce-header">
              <img
                src={logoSrc}
                alt="Logo"
                style={{ height: 78 }}
                className="ce-logo"
              />
              <div style={cityDate} className="ce-citydate">
                <div>
                  <Editable
                    enabled={isEditing}
                    initialText={ciudad}
                    onCommit={setCiudad}
                    ariaLabel="Ciudad"
                    block
                  />
                </div>
                <div style={{ marginTop: 6 }}>
                  <Editable
                    enabled={isEditing}
                    initialText={fechaLarga}
                    onCommit={setFechaLarga}
                    ariaLabel="Fecha"
                    block
                  />
                </div>
              </div>
            </div>

            {/* Línea azul única */}
            <div style={ruleRow}>
              <div style={blueRule} className="ce-bluebar" />
            </div>

            {/* Título */}
            <h2 style={title}>ENVÍO PAQUETERÍA</h2>

            {/* REMITENTE */}
            <div className="ce-section" style={centerBlock}>
              <div style={label} className="ce-label">
                REMITENTE:
              </div>

              <div style={lineBig} className="ce-line ce-big">
                <Editable
                  enabled={isEditing}
                  initialText={remitenteEmpresa}
                  onCommit={setRemitenteEmpresa}
                  ariaLabel="Empresa remitente"
                />
              </div>

              <div style={atnRow} className="ce-atn">
                ATN.&nbsp;
                <Editable
                  enabled={isEditing}
                  initialText={remitenteAtn}
                  onCommit={setRemitenteAtn}
                  ariaLabel="Atención remitente"
                />
              </div>

              <div style={line} className="ce-line">
                <Editable
                  enabled={isEditing}
                  initialText={remitenteDir1}
                  onCommit={setRemitenteDir1}
                  ariaLabel="Dirección remitente"
                />
              </div>

              <div style={line} className="ce-line">
                <Editable
                  enabled={isEditing}
                  initialText={remitenteCiudad}
                  onCommit={setRemitenteCiudad}
                  ariaLabel="Ciudad remitente"
                />
              </div>

              <div style={line} className="ce-line">
                Número de teléfono:&nbsp;
                <Editable
                  enabled={isEditing}
                  initialText={remitenteTelefono}
                  onCommit={setRemitenteTelefono}
                  ariaLabel="Teléfono remitente"
                />
              </div>
            </div>

            {/* DESTINATARIO */}
            <div
              className="ce-section"
              style={{ ...centerBlock, marginTop: 26 }}
            >
              <div style={label} className="ce-label">
                DESTINATARIO:
              </div>

              <div style={lineBig} className="ce-line ce-big">
                <Editable
                  enabled={isEditing}
                  initialText={destEmpresa}
                  onCommit={setDestEmpresa}
                  ariaLabel="Empresa destinatario"
                />
              </div>

              <div style={atnRow} className="ce-atn">
                ATN.&nbsp;
                <Editable
                  enabled={isEditing}
                  initialText={destAtn}
                  onCommit={setDestAtn}
                  ariaLabel="Atención destinatario"
                />
              </div>

              <div style={line} className="ce-line">
                <Editable
                  enabled={isEditing}
                  initialText={destDireccion}
                  onCommit={setDestDireccion}
                  ariaLabel="Dirección destinatario"
                  block
                />
              </div>

              <div style={line} className="ce-line">
                Número de teléfono:&nbsp;
                <Editable
                  enabled={isEditing}
                  initialText={destTelefono}
                  onCommit={setDestTelefono}
                  ariaLabel="Teléfono destinatario"
                />
              </div>
            </div>

            <div style={{ flexGrow: 1 }} />

            {/* Barras pie */}
            <div style={footerBarsWrap} className="footer-bars">
              <div style={footerBlue} className="footer-blue" />
              <div style={footerDark} className="footer-dark" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
